<div class="confirm-dialog" (click)="onCloseClick()">
  <div
    class="confirm-dialog__content"
    style="width: 70%"
    (click)="$event.stopPropagation()"
  >
    <p style="margin: 0">
      Please use the below link to continue the conversation in another device.
    </p>
    <div class="copy-link display-flex flex-align-center">
      <textarea
        id="clipboard-example-textarea"
        cols="45"
        rows="3"
        [(ngModel)]="chatLink"
        class="chat-input-area"
        readonly
      ></textarea>

      <mat-icon 
      class="copy-icon primary-btn" 
      [cdkCopyToClipboard]="chatLink"
       [ngStyle]="{
                'color': configs?.colors?.user_message_background || '#256EFF',
                '--hover-color': configs?.colors?.send_button_background || '#256EFF'
              }"
      >
        content_copy
      </mat-icon>
    </div>

    <div class="confirm-dialog__actions">
      <button 
      mat-stroked-button 
      class="restart-btn" 
      (click)="onCloseClick()"
      [ngStyle]="{
                'font-family': configs?.fonts?.chat_menu_font || configs?.fonts?.default_font,
              }"
      >
        Close
      </button>
    </div>
  </div>
</div>
